import React, { useState, useEffect } from "react";
import { useApolloClient } from '@apollo/client';
import {
  Form,
  Table,
  Switch,
  Select,
  Descriptions,
  Input,
  Card,
  Button,
  Space,
  Skeleton,
  Col,
  Row,
  Modal,
} from "antd";
import { DeleteFilled, EditFilled } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  InboxOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  handleSave,
  handleDelete,
  handleEdit,
  handleClear,
  getColumnSearchPropsText,
} from "./UseCases";
import localStorageService from "../../../../../../../services/localStorageService";

import {
  fetchDistributionCenters,
  insertDistributionCenter,
  updateDistributionCenter,
  deleteDistributionCenter,
  fetchSectors,
} from "../../queries/distributionCentersQueries";
import { statesList } from "../../../common/commonData";
import axios from "axios";
import { DistributionCentersScreenIndicator } from "./DistributionCentersScreenIndicator";
import { ConfigurationMoreSettings } from "../../../ConfigurationMoreSettings";
import calculateGeoEnclosure from "../../../../../../../services/geo-enclosure";
const companyId = localStorageService.get("companyId");

export const DistributionCentersScreen = () => {
  const apolloClient = useApolloClient();
  const [page, setPage] = useState(1); // Página inicial
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const { data: dataDistributionCenters, loading: loadingDistributionCenters } = useQuery(
    fetchDistributionCenters,
    {
      variables: {
        companyId,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      },
      fetchPolicy: "no-cache",
    }
  );

  const totalCount =
    dataDistributionCenters?.distributionCenters_aggregate?.aggregate?.count ||
    0;
  const [insDistributionCenter] = useMutation(insertDistributionCenter, {
    variables: { companyId },
    fetchPolicy: "no-cache",
  });
  const [delDistributionCenter] = useMutation(deleteDistributionCenter, {
    fetchPolicy: "no-cache",
  });
  const [updDistributionCenter] = useMutation(updateDistributionCenter, {
    fetchPolicy: "no-cache",
  });
  const [getSectors, dataSectors] = useLazyQuery(fetchSectors, {
    fetchPolicy: "no-cache",
  });
  const [clickedRow, setClickedRow] = useState("");

  const [distributionCenters, setDistributionCenters] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [form] = Form.useForm();
  const [sectors, setSectors] = useState([]);
  const [depart, setDepart] = useState("");
  const [city, setCity] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [geoClouser, setGeoClouser] = useState("");
  const [selectedSector, setSelectedSector] = useState("");

    const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    getSectors({ variables: { companyId } });
  }, []);

  useEffect(() => {
    if (
      !loadingDistributionCenters &&
      dataDistributionCenters?.distributionCenters?.length > 0
    ) {
      const items = dataDistributionCenters.distributionCenters.map((item) => {
        const {
          id,
          name,
          description,
          state,
          city,
          address,
          addressComplement,
          enabled,
          lat,
          lng,
          contactName,
          phone,
          email,
          sectorId,
        } = item;

        const sector = item.distributionCenterSector?.name || "";

        return {
          id,
          name,
          description,
          state,
          city,
          address,
          addressComplement,
          enabled,
          lat,
          lng,
          contactName,
          phone,
          email,
          sectorId,
          sector,
        };
      });

      setDistributionCenters(items);
    }
  }, [loadingDistributionCenters, dataDistributionCenters]);

  useEffect(() => {
    if (
      !dataSectors.loading &&
      dataSectors.data?.sectors?.length > 0
    ) {
      const items = dataSectors.data.sectors.map(({ id, name, sectorPolygons }) => ({
        id,
        name,
        sectorPolygons,
      }));
      setSectors(items);
    }
  }, [dataSectors.loading, dataSectors.data]);

  const columns = [
    {
      title: "Nombre",
      key: "name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...getColumnSearchPropsText("Nombre", "name"),
    },
    {
      title: "Descripción",
      key: "description",
      dataIndex: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      ...getColumnSearchPropsText("Descripción", "description"),
    },
    {
      title: "Nombre de contacto",
      key: "contactName",
      dataIndex: "contactName",
      sorter: (a, b) => a.contactName.localeCompare(b.contactName),
      ...getColumnSearchPropsText("Nombre de contacto", "contactName"),
    },
    {
      title: "Teléfono",
      key: "phone",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.localeCompare(b.phone),
      ...getColumnSearchPropsText("Teléfono", "phone"),
    },
    {
      title: "Correo",
      key: "email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      ...getColumnSearchPropsText("Correo", "email"),
    },
    {
      title: "Zona",
      key: "sector",
      dataIndex: "sector",
      sorter: (a, b) => a.sector.localeCompare(b.sector),
      ...getColumnSearchPropsText("Zona", "sector"),
    },
    {
      title: "Departamento",
      key: "state",
      dataIndex: "state",
      sorter: (a, b) => a.state.localeCompare(b.state),
      ...getColumnSearchPropsText("Departamento", "state"),
    },
    {
      title: "Ciudad",
      key: "city",
      dataIndex: "city",
      sorter: (a, b) => a.city.localeCompare(b.city),
      ...getColumnSearchPropsText("Ciudad", "city"),
    },
    {
      title: "Dirección",
      key: "address",
      dataIndex: "address",
      sorter: (a, b) => a.address.localeCompare(b.address),
      ...getColumnSearchPropsText("Dirección", "address"),
    },
    {
      title: "Habilitado",
      key: "enabled",
      dataIndex: "enabled",
      align: "center",
      sorter: {
        compare: (a, b) => a.enabled - b.enabled,
      },
      render: (value) => <Switch checked={value} disabled />,
    },
  ];

  return (
    <Col className="children-inner-container-with-bg">
      <Row className="children-inner-row">
        <Col span={5} className="children-inner-col">
          <DistributionCentersScreenIndicator
            value={distributionCenters.length}
            label={"Total Centros de distribución"}
          >
            <InboxOutlined
              style={{ backgroundColor: "var(--primaryColor)" }}
              className="report-indicator-icon"
            />
          </DistributionCentersScreenIndicator>
        </Col>
        <Col span={5} className="children-inner-col">
          <DistributionCentersScreenIndicator
            value={distributionCenters.filter((item) => item.enabled).length}
            label={"Centros de distribución Activos"}
          >
            <CheckOutlined
              style={{ backgroundColor: "#9ccc65" }}
              className="report-indicator-icon"
            />
          </DistributionCentersScreenIndicator>
        </Col>
        <Col span={5} className="children-inner-col">
          <DistributionCentersScreenIndicator
            value={distributionCenters.filter((item) => !item.enabled).length}
            label={"Centros de distribución Inactivos"}
          >
            <ClockCircleOutlined
              style={{ backgroundColor: "#ffba57" }}
              className="report-indicator-icon"
            />
          </DistributionCentersScreenIndicator>
        </Col>
        <Col span={3} offset={3} className="children-inner-col">
          <Button
            type="primary"
            size="large"
            className="children-inner-button"
            icon={<EditOutlined />}
            onClick={showModal}
          >
            {clickedRow.length === 0 ? "Crear" : "Editar"}
          </Button>
        </Col>
        <Col span={3} className="children-inner-col">
          <Button
            type="primary"
            size="large"
            className="children-inner-button"
            icon={<DeleteFilled />}
            onClick={() =>
              handleDelete(
                clickedRow,
                delDistributionCenter,
                distributionCenters,
                setDistributionCenters,
                setClickedRow
              )
            }
            disabled={clickedRow.length === 0}
          >
            Eliminar
          </Button>
        </Col>
      </Row>
      <Row>
        <Skeleton loading={loadingDistributionCenters} active>
          <Table
            className="children-table"
            columns={columns}
            dataSource={distributionCenters}
            size="small"
            rowKey="id"
            pagination={{
              pageSize: rowsPerPage,
              current: page,
              total: totalCount,
              showSizeChanger: true,
              pageSizeOptions: ["10", "13", "20", "50", "100"],
              showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} centros de distribución`,
              onChange: (newPage, newPageSize) => {
                setPage(newPage);
                setRowsPerPage(newPageSize);
              },
              onShowSizeChange: (current, size) => {
                setPage(1);
                setRowsPerPage(size);
              },
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  if (clickedRow.length === 0 || clickedRow !== record.id) {
                    setClickedRow(record.id);
                    handleEdit(record, setIsEditing, form);
                  } else {
                    handleClear(setIsEditing, form);
                    setClickedRow("");
                  }
                },
              };
            }}
            rowClassName={(record) => [
              "mouse-row-enter",
              record.id === clickedRow ? "table-row-color" : "",
            ]}
          />
        </Skeleton>
      </Row>
    </Col>
  );
};
